import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { node_server } from "../../../../../../../../../constants";
import { useTheme } from "../../../../../../../../../context/themeContext";
import {
	sendProjectCompletedEmail,
	sendRemovedByHostEmail,
} from "../../../../../../../../../helpers/emails";
import DeleteConfirmation from "../delete-confirmation";
import styles from "./style.module.css";

const AcceptedState = ({ setStatus, status, item }) => {
	const { theme } = useTheme();
	const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

	const handleCancel = async (item) => {
		setStatus("Pending");
		const response = await axios.post(
			`${node_server}/api/projects/applications-status`,
			{
				projectId: item.project_id,
				userId: item.user_id,
				status: "Pending",
			},
			{ withCredentials: true },
		);
		const error = response.status !== 200 ? response.data : null;

		if (error) {
			throw error;
		} else {
			await sendRemovedByHostEmail(item.project_id, item.user_id);
		}
	};

	const handleCompleted = async () => {
		setStatus("Completed");
		const response = await axios.post(
			`${node_server}/api/projects/applications-status`,
			{
				projectId: item.project_id,
				userId: item.user_id,
				status: "Completed",
			},
			{ withCredentials: true },
		);
		const error = response.status !== 200 ? response.data : null;

		if (error) {
			throw error;
		} else {
			await sendProjectCompletedEmail(item.project_id, item.user_id);
		}
	};

	return (
		<Box className={styles.actions}>
			<DeleteConfirmation
				isOpen={isCancelModalOpen}
				setIsOpen={setIsCancelModalOpen}
				onDelete={handleCancel}
				project={item}
				text={"cancel"}
			/>
			<Box
				className={styles.remove}
				onClick={() => setIsCancelModalOpen(true)}
			>
				<Typography
					variant="body1"
					color={theme.palette.darkgrey.darkgrey400}
					sx={{
						fontSize: "12px",
						fontWeight: "700",
						letterSpacing: 2,
						textTransform: "uppercase",
						display: status === "Completed" && "none",
					}}
				>
					Cancel
				</Typography>
			</Box>
			<Button
				variant="contained"
				sx={{
					fontSize: "12px",
					fontWeight: "700",
					padding: "8px 20px",
					letterSpacing: 1,
				}}
				disabled
			>
				Accepted
			</Button>
			<Button
				variant="contained"
				onClick={handleCompleted}
				sx={{
					bgcolor: "#00B0F0",
					color: "#FFF",
					fontSize: "12px",
					fontWeight: "700",
					padding: "8px 20px",
					letterSpacing: 1,
				}}
				disabled={status === "Completed"}
			>
				{status === "Completed" ? "Completed" : "Complete"}
			</Button>
		</Box>
	);
};

export default AcceptedState;
